import { fetchPointsHistory, fetchOrderOfPoints } from '../requests'
import actions from './actions'
import { normalizePointsHistory } from './normalize'
import pointsHistorySelectors from './selectors'

export const operationFetchPointsHistory = () => async (dispatch) => {
  dispatch(actions.fetchPointsHistoryStart())

  try {
    const pointsHistory = await fetchPointsHistory()
    const normalizedpointsHistory = normalizePointsHistory(pointsHistory)

    dispatch(actions.fetchPointsHistorySuccess(normalizedpointsHistory))
  } catch (error) {
    dispatch(actions.fetchPointsHistoryFail())
  }
}

export const operationFetchOrderOfPoints = () => async (dispatch, getState) => {
  const state = getState()
  const shouldFetchOrderOfpoints = pointsHistorySelectors.getShouldFetchOrderOfPoints(state)

  if (shouldFetchOrderOfpoints) {
    dispatch(actions.fetchPointsHistoryStart())

    try {
      const orderOfActivityTypes = await fetchOrderOfPoints()

      dispatch(actions.fetchOrderOfPointsSuccess(orderOfActivityTypes))
    } catch (error) {
      dispatch(actions.fetchOrderOfPointsFail())
    }
  }
}
